import React from "react";
import "./template-creation.scss";
import TemplateCreationFormRightTopNew from "./template-creation-form-right-top-new";
import TemplateCreationFormRightBottomNew from "./template-creation-form-right-bottom-new";
import { FluentField } from "../../../../../components/FluentUI/Fluent-Field";
import PropTypes from "prop-types";

const TemplateCreationFormRightNew = ({
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
  setFieldValue,
  departments,
  selectedDepartment,
  setSelectedDepartment,
  users,
  updateOwners,
  updateMembers,
  isSuperAdmin,
  handleDepartmentChange,
  isEdit,
  onMultiOwnerToggle,
  initialMultiOwner
}) => {
  return (
    <div className="right-row">
      <div className="right-header" >
        <FluentField label="Template Defaults" size="large"/>
      </div>
      <TemplateCreationFormRightTopNew
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched}
        setFieldValue={setFieldValue}
      />

      <TemplateCreationFormRightBottomNew
        values={values}
        errors={errors}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        departments={departments}
        selectedDepartment={selectedDepartment}
        setSelectedDepartment={setSelectedDepartment}
        users={users}
        updateOwners={updateOwners}
        updateMembers={updateMembers}
        isSuperAdmin={isSuperAdmin}
        handleDepartmentChange={handleDepartmentChange}
        isEdit={isEdit}
        onMultiOwnerToggle={onMultiOwnerToggle}
        initialMultiOwner={initialMultiOwner}
      />
    </div>
  );
};

TemplateCreationFormRightNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  departments: PropTypes.array.isRequired,
  selectedDepartment: PropTypes.object,
  setSelectedDepartment: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  updateOwners: PropTypes.func.isRequired,
  updateMembers: PropTypes.func.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  handleDepartmentChange: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  onMultiOwnerToggle: PropTypes.func,
  initialMultiOwner: PropTypes.bool,
};

export default TemplateCreationFormRightNew;
